// extracted by mini-css-extract-plugin
module.exports = {"stripeConnect":"StripeButton_stripeConnect__yZxiA","dark":"StripeButton_dark__ed6ZX","blue":"StripeButton_blue__2j7FK"};